<template>
  <div class="signup">
    
    <!-- dialog for warning -->
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="400"
      >
        <v-card>
          <v-card-title class="text-h5 brown lighten-2 white--text mb-5">
            ㅜㅜ
          </v-card-title>
          <v-card-text>
            누군가 이미 사용중이니 다른 멋진 닉네임을 생각해 보세요!
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="brown"
              text
              @click="dialog = false"
            >
              OK!
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- form -->
    <h1 class="blue-grey--text text-center mt-5">회원가입</h1>
    <v-container>
      <v-row justify="center">
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="5"
          xl="4"
          class="text-center"
        >
          <v-form class="pa-3" v-model="valid" ref="form">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="이메일"
                    required
                    prepend-icon="mdi-account-box-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    type="password"
                    v-model="password"
                    :counter="8"
                    :rules="passwordRules"
                    label="비밀번호"
                    required
                    prepend-icon="mdi-lock-outline"
                ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    :counter="10"
                    :rules="nameRules"
                    label="이름"
                    required
                    prepend-icon="mdi-tag-outline"
                ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="alias"
                    :counter="10"
                    :rules="aliasRules"
                    label="닉네임"
                    required
                    prepend-icon="mdi-fountain-pen-tip"
                ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    dark
                    color="blue-grey lighten-2"
                    @click.prevent="signup"
                    :loading="loading"
                  >가입하기</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>     
    </v-container>
  </div>
</template>

<script>
import { auth } from '../firebase/init'
import { db } from '../firebase/init'
import slugify from 'slugify'

export default {
  name: 'Signup',
  data: () => ({
    dialog: false,
    loading: false,
    valid: true,
    alias: '',
    email: '',
    emailRules: [
      v => !!v || '이메일은 꼭 필요해요',
      v => /.+@.+\..+/.test(v) || '유효한 이메일이 필요해요',
    ],
    password: '',
    passwordRules: [
      v => !!v || '비밀번호는 꼭 필요해요',
      v => (v && v.length >= 8) || '비밀번호는 8자 이상으로 하세요',
    ],
    name: '',
    nameRules: [
      v => !!v || '이름 꼭 필요해요',
      v => (v && v.length <= 10) || '이름은 10자 이내로 만드세요',
    ],
    slug: '',
    aliasRules: [
      v => !!v || '닉네임은 꼭 필요해요',
      v => (v && v.length <= 10) || '닉네임은 10자 이내로 만드세요',
    ]
  }),

  methods: {
    signup () {
        if(this.$refs.form.validate()){
          this.loading = true;
          this.slug = slugify(this.alias, {
              replacement: '-',
              remove: /[$*_+~.()'"!\-:@]/g,
              lower: true
          });
          let ref = db.collection('users').doc(this.slug)
          ref.get().then(doc => {
            if(doc.exists){
              this.dialog = true;
            } else {
              auth.createUserWithEmailAndPassword(this.email, this.password)
                .then(cred => {
                  ref.set({
                    email: cred.user.email,
                    id: cred.user.uid,
                    name: this.name, 
                    alias: this.alias,
                  })
                }).then(() => {
                  this.loading = false;
                  this.$router.push({ name: 'Home' })
                }).catch(err => {
                  console.log(err.message)
                })
            }
          })
        }
    },
    reset () {
      this.$refs.form.reset()
    }
  },
};
</script>

<style>
.v-form {
  border: 1px solid #B0BEC5;
}
</style>